import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "9.25",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "1.25",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "5.25",
      cy: "10",
      r: "1.25",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "14.75",
      cy: "10",
      r: "1.25",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }